import { Injectable } from "@angular/core";

export const enum StorageType {
    String,
    JSON,
    Boolean,
}

@Injectable({
    providedIn: 'root'
})
export class PersistantStorageService {

    public setData(key: string, value: any, type?: StorageType) {

        if (type === StorageType.JSON) {
            localStorage.setItem(key, JSON.stringify(value));
        } else {
            localStorage.setItem(key, value.toString());
        }

    }

    public getData(key: string, type?: StorageType) {

        let val = null;
        if (type === StorageType.JSON) {
            val = localStorage.getItem(key);
            if (val !== null) {
                val = JSON.parse(val);
            }
        } else if (type === StorageType.Boolean) {
            val = localStorage.getItem(key) === "true";
        } else {
            val = localStorage.getItem(key);
        }
        return val;

    }

    public removeData(key: string) {
        localStorage.removeItem(key);
    }

}
